import React from "react";
import AddPersonaForm from "./AddPersonaForm";

const AddPersona = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Nuevo Personal"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddPersonaForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddPersona;
